'use client';
import { GlobeOutline } from '@raresail/react-ionicons';
import { languageNames } from '@/lib/i18n/settings';
import { useTranslation } from '@/contexts/language-context';
import { useRef } from 'react';
import { twMerge } from 'tailwind-merge';

export function LanguageSwitcher({
  className,
  menuClassName,
  containerClassName,
  icon = true
}) {
  const dropRef = useRef();
  const { lng, changeLanguage } = useTranslation();

  const doChangeLanguage = (lng) => {
    document.activeElement.blur();
    changeLanguage(lng);
  };
  return (
    <div className={twMerge('dropdown group', containerClassName)}>
      <div
        ref={dropRef}
        tabIndex="0"
        role="button"
        className={twMerge(
          'btn btn-sm rounded-full cursor-pointer border-0',
          className
        )}
        style={{ cursor: 'pointer' }}
      >
        {icon === true && <GlobeOutline className="w-3 h-3 md:w-4 md:h-4" />}
        {`${lng}`.toUpperCase()}
      </div>
      <ul
        tabIndex="-1"
        className={twMerge(
          'dropdown-content menu bg-base-100 text-base-content rounded-box z-1 w-32 p-2 shadow',
          menuClassName
        )}
      >
        {Object.keys(languageNames).map((newLng) => {
          const langName = languageNames[newLng];
          return (
            <li key={newLng}>
              <button onClick={() => doChangeLanguage(newLng)}>
                {langName}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
